import React, { useState, useEffect } from "react";
import PrimaryButton from "../../../components/primaryButton/PrimaryButton";
import EditForm from "../../../components/field/EditForm";
import DriverPaymentConfigurationForm from "../../../components/payments/DriverPaymentsConfigurationForm";
import { parseDriverPaymentSettings } from "../../../components/payments/PaymentsConfigUtil";
import { getDriverPaymentSettings, saveDriverPaymentSettings } from "../../../utilities/apiUtils";
import SpinnerImage from "../../../assets/images/spinner.gif";

function DriverPaymentSettingsForm(props) {
  const [settingsFetched, setSettingsFetched] = useState(false);
  const [settings, setSettings] = useState({});
  const [settingsSaved, setSettingsSaved] = useState(false);
  const [saveInProgress, setSettingsSaveInProgress] = useState(false);
  const [isValid, setIsValid] = useState(true);
  const [validationCounter, setValidationCounter] = useState(0);
  const [errorText, setErrorText] = useState("");

  useEffect(() => {
    getDriverPaymentSettings().then((res) => {
      if (res.data) {
        setSettings(res.data);
        setSettingsFetched(true);
      }
    });
  }, []);

  const cancel = () => {
    props.history.goBack();
  };

  const save = () => {
    setValidationCounter(validationCounter + 1);
    console.log("isValid", isValid);
    setSettingsSaved(false);
    if (!isValid) {
      return;
    }

    setSettingsSaveInProgress(true);
    const settingsParsed = parseDriverPaymentSettings(settings);
    setSettings(settingsParsed);

    saveDriverPaymentSettings(settingsParsed).then((res) => {
      setSettingsSaveInProgress(false);
      if (res.data) {
        setSettingsSaved(true);
      } else {
        setErrorText(`Settings save failed. Details: ${JSON.stringify(res)}.`);
      }
    });
  };

  const processSettingsChanged = (newSettings, isValid) => {
    setSettings(newSettings);
    setIsValid(isValid);
  };

  const formComponents = [
    <DriverPaymentConfigurationForm
      settings={settings}
      onChanged={processSettingsChanged}
      validationCounter={validationCounter}
    />
  ];

  const form = (
    <EditForm
      components={formComponents}
      continueAction={<PrimaryButton value="Save" />}
      cancelAction={<PrimaryButton onClick={() => cancel()} value="Cancel" />}
      onValidated={(result) => {
        if (result) {
          save();
        }
      }}
    />
  );

  return (
    <div className="driverPaymentSettingsForm">
      {settingsSaved && <div class="alert alert-success">Settings saved.</div>}
      {saveInProgress && <div class="alert alert-primary"><img src={SpinnerImage} /> Saving settings...</div>}
      {errorText != "" && <div className="alert alert-danger">{errorText}</div>}
      {settingsFetched ? (
        <div>{form}</div>
      ) : (
        <div class="alert alert-primary"><img src={SpinnerImage} /> Loading...</div>
      )}
    </div>
  );
}

export default DriverPaymentSettingsForm;
